import './scss/main.scss';
import Swiper from 'swiper/bundle';
import naja from 'naja';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import netteForms from 'nette-forms';
import lightbox from 'lightbox2';

netteForms.initOnLoad();
naja.initialize();
const news_wiper = new Swiper('#swiper', {
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 7000
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  }
});